<div class="modal-overlay" (click)="closeModal()">
    
    <!-- Content -->
    <div class="modal-container" (click)="$event.stopPropagation()">
        
        <!-- Header -->
        <div class="modal-header">
            <div class="header-title">
                <h2>{{ 'shared.editImage.title' | translate }}</h2>
                @if (getTotalImages() > 1) {
                    <span class="image-counter">
                        {{ 'shared.editImage.imageCounter' | translate:{ current: currentImageIndex() + 1, total: getTotalImages() } }}
                    </span>
                }
            </div>
            <button class="button-close" (click)="closeModal()" type="button">
                <ra-icon icon="close-square" varColor="currentColor" [size]="24" />
            </button>
        </div>

        <!-- Toolbar -->
        <div class="modal-toolbar">
            <!-- Formas -->
            <div class="toolbar-group">

                <!-- Quadrado vazio -->
                <button 
                    class="toolbar-button" 
                    [title]="'shared.editImage.tools.emptySquare' | translate"
                    [raTooltip]="{ text: ('shared.editImage.tools.emptySquare' | translate), position: 'top' }"
                    (click)="$event.stopPropagation(); setTool('rect')">
                    <ra-icon icon="format-square" varColor="currentColor" [size]="18" />
                </button>
                
                <!-- Círculo vazio -->
                <button 
                    class="toolbar-button" 
                    [title]="'shared.editImage.tools.emptyCircle' | translate"
                    [raTooltip]="{ text: ('shared.editImage.tools.emptyCircle' | translate), position: 'top' }"
                    (click)="$event.stopPropagation(); setTool('circle')">
                    <ra-icon icon="status" varColor="currentColor" [size]="18" />
                </button>
            </div>

            <!-- Linhas e Setas -->
            <div class="toolbar-group">
                <button 
                    class="toolbar-button" 
                    [title]="'shared.editImage.tools.arrow' | translate"
                    [raTooltip]="{ text: ('shared.editImage.tools.arrow' | translate), position: 'top' }"
                    (click)="$event.stopPropagation(); setTool('arrow')">
                    <ra-icon icon="arrow-right" varColor="currentColor" [size]="18" />
                </button>
                <button 
                    class="toolbar-button" 
                    [title]="'shared.editImage.tools.line' | translate"
                    [raTooltip]="{ text: ('shared.editImage.tools.line' | translate), position: 'top' }"
                    (click)="$event.stopPropagation(); setTool('line')">
                    <ra-icon icon="minus" varColor="currentColor" [size]="18" />
                </button>
            </div>

            <!-- Texto -->
            <div class="toolbar-group">
                
                <button 
                    class="toolbar-button" 
                    [title]="'shared.editImage.tools.text' | translate"
                    [raTooltip]="{ text: ('shared.editImage.tools.text' | translate), position: 'top' }"
                    (click)="$event.stopPropagation(); setTool('text')">
                    <ra-icon icon="text" varColor="currentColor" [size]="18" />
                </button>
                
                <!-- Legenda -->
                <button 
                    class="toolbar-button" 
                    [title]="'shared.editImage.tools.caption' | translate"
                    [raTooltip]="{ text: ('shared.editImage.tools.caption' | translate), position: 'top' }"
                    (click)="$event.stopPropagation(); setTool('caption')">
                    <ra-icon icon="document-normal" varColor="currentColor" [size]="18" />
                </button>
            </div>

            <!-- Desenho Livre -->
            <div class="toolbar-group">
                <button 
                    class="toolbar-button" 
                    [title]="'shared.editImage.tools.freehand' | translate"
                    [raTooltip]="{ text: ('shared.editImage.tools.freehand' | translate), position: 'top' }"
                    (click)="$event.stopPropagation(); setTool('freehand')">
                    <ra-icon icon="edit-2" varColor="currentColor" [size]="18" />
                </button>
                
                <button 
                    class="toolbar-button" 
                    [title]="'shared.editImage.tools.marker' | translate"
                    [raTooltip]="{ text: ('shared.editImage.tools.marker' | translate), position: 'top' }"
                    (click)="$event.stopPropagation(); setTool('marker')">
                    <ra-icon icon="brush" varColor="currentColor" [size]="18" />
                </button>
            </div>

            <!-- Seletor de Cor -->
            <div class="toolbar-group toolbar-group-color">
                <div class="color-picker-wrapper" [raTooltip]="{ text: ('shared.editImage.tools.selectColor' | translate), position: 'top' }">
                    <input 
                        type="color" 
                        class="color-picker"
                        [value]="selectedColor()"
                        (change)="onColorChange($event)"
                        [title]="'shared.editImage.tools.selectColor' | translate"
                    />
                </div>
            </div>

            <!-- Botão de deletar (aparece quando há marcador selecionado) -->
            @if (hasSelectedMarker()) {
                <div class="toolbar-group toolbar-group-delete">
                    <button 
                        class="toolbar-button toolbar-button-delete" 
                        [title]="'shared.editImage.tools.removeSelected' | translate"
                        [raTooltip]="{ text: ('shared.editImage.tools.removeSelected' | translate), position: 'top' }"
                        (click)="$event.stopPropagation(); deleteSelectedMarker()">
                        <ra-icon icon="trash" varColor="currentColor" [size]="18" />
                    </button>
                </div>
            }
        </div>

        <!-- Content -->
        <div class="modal-content">
            
            <!-- Navigation Arrows (only show if multiple images) -->
            @if (getTotalImages() > 1) {
                <button 
                    class="nav-button nav-button-prev"
                    [disabled]="!hasPreviousImage() || isSaving()"
                    (click)="$event.stopPropagation(); previousImage()"
                    [raTooltip]="{ text: ('shared.editImage.previousImage' | translate), position: 'left' }">
                    <ra-icon icon="arrow-left" varColor="currentColor" [size]="20" />
                </button>
            }

            <!-- Image Container -->
            <div class="image-container">
                <!-- Loading -->
                @if (isLoadingImage()) {
                    <div class="loading-overlay">
                        <ra-loading size="large" />
                    </div>
                }
                
                <!-- Imagem original (necessária para o MarkerArea usar como referência) -->
                <img 
                    #imageElement 
                    crossorigin="anonymous"
                    [style.opacity]="isLoadingImage() ? '0' : '1'"
                />
            </div>

            <!-- Navigation Arrows (only show if multiple images) -->
            @if (getTotalImages() > 1) {
                <button 
                    class="nav-button nav-button-next"
                    [disabled]="!hasNextImage() || isSaving()"
                    (click)="$event.stopPropagation(); nextImage()"
                    [raTooltip]="{ text: ('shared.editImage.nextImage' | translate), position: 'right' }"
                >
                    <ra-icon icon="arrow-right" varColor="currentColor" [size]="20" />
                </button>
            }
        </div>

        <!-- Footer -->
        <div class="modal-footer">

            <!-- Cancelar -->
            <ra-button 
                [label]="'common.cancel' | translate" 
                [type]="'primary-outline'" 
                [disabled]="isSaving()"
                (click)="closeModal()"
            />

            <!-- Salvar -->
            <ra-button 
                [label]="'common.save' | translate" 
                [type]="'primary'"
                [loading]="isSaving()"
                [disabled]="isSaving()"
                (click)="save()"
            />
        </div>
    </div>
</div>
